var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSwapIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0982 15.9776L11.2143 15.0937L13.5849 12.7232H3.75C1.68225 12.7232 0 11.0409 0 8.97319V7.28569H1.25V8.97319C1.25 10.3517 2.3715 11.4732 3.75 11.4732H13.5849L11.2143 9.10266L12.0982 8.21875L15.9776 12.0982L12.0982 15.9776ZM16 8.66069H14.75V7.00444C14.75 5.62594 13.6285 4.50444 12.25 4.50444H2.41512L4.78569 6.875L3.90181 7.75887L0.022375 3.87944L3.90181 0L4.78569 0.883875L2.41512 3.25444H12.25C14.3177 3.25444 16 4.93669 16 7.00444V8.66069Z",
    fill: "#83899B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwapIcon);
export default __webpack_public_path__ + "static/media/swap-icon.c5cd44bb954588a529395125372dd394.svg";
export { ForwardRef as ReactComponent };